"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("@babel/runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

var _webxJs = require("@didi/webx-js");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function ownKeys(object, enumerableOnly) {
    try {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function func_trir_e6f9dcb162ddc91bed10b034c2858b85(sym) {
                try {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_e6f9dcb162ddc91bed10b034c2858b85@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('ownKeys@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function _objectSpread(target) {
    try {
        for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function func_trir_c0676a94f483fe5106ed726722866000(key) {
                try {
                    (0, _defineProperty3.default)(target, key, source[key]);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_c0676a94f483fe5106ed726722866000@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a(key) {
                try {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        return target;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_objectSpread@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var wxsModules = {};
global.currentSrcMode = "wx";

(0, _core.createComponent)({
  name: 'Coupon',
  properties: {
    // 券详情
    couponInfo: {
      type: Object,
      value: function value() {
    try {
        return {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('value@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
    },
    isH5: {
      type: Boolean,
      value: false
    }
  },
  computed: {
    /* normal: 普通券; merchant: 商家券 */
    sourceType: function sourceType() {
    try {
        return this.couponInfo.source_type || 'normal';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('sourceType@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    merchantStyle: function merchantStyle() {
    try {
        return { backgroundImage: 'url(\''.concat(this.couponInfo.icon, '\')') };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('merchantStyle@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},

    /* 券的面值类型 */

    /* 3: 抵扣类型、100: 打折类型、103: 通乘类型、111: 预估券 */
    couponType: function couponType() {
    try {
        var res = '';
        switch (Number(this.couponInfo.couponType)) {
        case 3:
            res = 'decution';
            break;
        case 100:
            res = 'discount';
            break;
        case 103:
            res = 'pass';
            break;
        case 111:
            res = 'estimate';
            break;
        default:
            res = 'unknown';
        }
        return res;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponType@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showBottomTip: function showBottomTip() {
    try {
        return false;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showBottomTip@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    bottomTipClass: function bottomTipClass() {
    try {
        return this.showBottomTip ? 'with-bottom-tip' : '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('bottomTipClass@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    tipLeft: function tipLeft() {
    try {
        var text = '';
        if (this.showBottomTip) {
            var update_type = this.couponInfo.updateInfo.update_type;
            switch (update_type) {
            case 1:
                text = '延长';
                break;
            case 2:
                text = '现在发单\uFF0C'.concat(this.couponValue, '元变');
                break;
            case 3:
                text = '现在发单\uFF0C'.concat(this.couponValue, '折变');
                break;
            default:
                text = '';
            }
        }
        return text;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('tipLeft@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    tipCenter: function tipCenter() {
    try {
        var text = '';
        if (this.showBottomTip) {
            var update_type = this.couponInfo.updateInfo.update_type;
            switch (update_type) {
            case 1:
                text = ''.concat(this.couponInfo.updateInfo.extend_day, '天');
                break;
            case 2: {
                    var newAmount = Number(Number(this.couponInfo.updateInfo.new_amount / 100).toFixed(2));
                    text = ''.concat(newAmount, '元');
                    break;
                }
            case 3: {
                    var newDiscount = Number(this.couponInfo.updateInfo.new_discount / 10).toFixed(1);
                    text = ''.concat(newDiscount, '折');
                    break;
                }
            default:
                text = '';
            }
        }
        return text;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('tipCenter@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    tipRight: function tipRight() {
    try {
        var text = '';
        var update_type = this.couponInfo.updateInfo.update_type;
        if (update_type === 1) {
            text = '有效期';
        }
        return text;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('tipRight@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},

    /* 券面值 */
    couponValue: function couponValue() {
    try {
        return this.couponInfo.couponAmt;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponValue@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},

    /* 券面值 单位 */
    unit: function unit() {
    try {
        return this.couponInfo.couponUnit;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('unit@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    tip: function tip() {
    try {
        var _this$couponInfo = this.couponInfo, source_type = _this$couponInfo.source_type, couponType = _this$couponInfo.couponType, couponMaxAmt = _this$couponInfo.couponMaxAmt, taskTypeDesc = _this$couponInfo.taskTypeDesc;
        if (source_type === 'task') {
            return taskTypeDesc;
        }
        switch (couponType) {
        case 100:
        case 111:
            return '最高抵扣'.concat(couponMaxAmt, '元');
        case 103:
            return ''.concat(this.couponInfo.amount / 100, '元内一口价').concat(this.couponInfo.v_amount / 100, '元');
        default:
            return '';
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('tip@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    couponName: function couponName() {
    try {
        return this.couponInfo.couponName || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponName@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    couponDescription: function couponDescription() {
    try {
        var _this$couponInfo2;
        if (Number(this.couponInfo.couponType) === 123 && Array.isArray((_this$couponInfo2 = this.couponInfo) === null || _this$couponInfo2 === void 0 ? void 0 : _this$couponInfo2.showrule)) {
            var rule = this.couponInfo.showrule.find(function func_trir_f893f4d4759536580a94174d5a8b5932(item) {
                try {
                    return item.ruleid === 87;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_f893f4d4759536580a94174d5a8b5932@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
            return rule !== null && rule !== void 0 && rule.show_rule_name && rule !== null && rule !== void 0 && rule.show_rule_values ? rule.show_rule_name + rule.show_rule_values : '';
        }
        return this.couponInfo.couponDesc || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('couponDescription@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    expireDay: function expireDay() {
    try {
        var expireDay = this.couponInfo.expire_day;
        if (this.couponInfo.source_type === 'energy') {
            if (this.couponInfo.valid_period_type === 1) {
                expireDay = this.couponInfo.valid_period_length;
            }
        }
        return expireDay && Number(expireDay) > 0;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('expireDay@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    gap: function gap() {
    try {
        var originExpireTime = this.couponInfo.couponExpiredTime;
        var formatedExpireTime = originExpireTime.replace(/-/g, '/');
        var expireDate = new Date(formatedExpireTime);
        var currentDate = new Date();
        var gap = Date.parse(expireDate) - Date.parse(currentDate);
        return gap;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('gap@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    gapDay: function gapDay() {
    try {
        var gapDay = this.gap / 1000 / 60 / 60 / 24;
        return gapDay;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('gapDay@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    initTimeStamp: function initTimeStamp() {
    try {
        var timeStamp = Date.parse(new Date(this.gap)) || 0;
        return timeStamp / 1000;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('initTimeStamp@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    expireText: function expireText() {
    try {
        var expireTime = this.couponInfo.couponExpiredTime.split(' ')[0];
        return '有效期至: '.concat(expireTime);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('expireText@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showButton: function showButton() {
    try {
        var inner_env = (0, _webxJs.xenv)() === 'passenger' || (0, _webxJs.xenv)() === 'wxmp' || (0, _webxJs.xenv)() === 'alimp';
        console.log('inner_env', inner_env);
        var condition1 = this.gap > 0 && this.sourceType === 'normal';
        var condition2 = inner_env && this.buttonText === '去使用';
        return condition1 && condition2;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showButton@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},

    /* 按钮文案 */
    buttonText: function buttonText() {
    try {
        return '去使用';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('buttonText@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  methods: {
    handleCouponAction: function handleCouponAction() {
    try {
        this.triggerEvent('action', {
            type: 'tap',
            params: _objectSpread(_objectSpread({}, this.couponInfo), {}, { buttonText: this.buttonText })
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleCouponAction@@../../../../src/components/common/coupon.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  }
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "component", "", "coupon505df63e", {}, // @ts-ignore
{}, // @ts-ignore
{
  'count-down': (0, _optionProcessor.getComponent)(require("./count-down.mpx?component=true&componentId=count-down862c7190")),
  'mpx-button': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?component=true"), {
    __mpxBuiltIn: true
  })
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));